import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActionsTorchOn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.081 4.735h1.905V.925H9.081v3.81zm-3.088 1.28L4.646 7.36 1.953 4.668 3.299 3.32l2.694 2.694zM16.768 3.32l1.347 1.348-2.694 2.693-1.347-1.346 2.694-2.694zM0 11.825V9.92h3.3v1.905H0zM16.715 9.92v1.905H20V9.92h-3.285z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.922 16.342a5.238 5.238 0 1 1 6.667 0v3.102H6.921v-3.102zm6.666-4.041c0 1.33-.778 2.477-1.904 3.012v2.226H8.826v-2.226a3.334 3.334 0 1 1 4.762-3.012z",
		fill: "currentColor"
	})]
});
export default SvgActionsTorchOn;
